import { useQuery } from "@tanstack/react-query";
import { partnerDashboardService } from "@/services/partner-dashboard-service";
import { resolvePartnerRevenue } from "../utils/partnerRevenueMetric";

const ALL_TIME_FROM = "2000-01-01T00:00:00.000Z";

/**
 * All-time partner revenue of a tenant (EUR). A failed request gives null
 * without a toast: a tenant without the `guesteria_partners` feature answers
 * 403, and the page just shows no revenue (DV-168).
 * `tenantMode` (`?tenantId=`, platform admins): the request names the tenant
 * in `x-tenant-id` (DV-168); tenant roles read their own tenant without it.
 */
export const useHotelPartnerRevenue = (
  tenantId: string | undefined,
  { tenantMode = false }: { tenantMode?: boolean } = {},
) =>
  useQuery<number | null>({
    queryKey: ["hotels", "partner-revenue", tenantId || "", tenantMode],
    enabled: Boolean(tenantId),
    queryFn: async () => {
      try {
        const summary = await partnerDashboardService.getTotalRevenue(
          tenantId!,
          { from: ALL_TIME_FROM, to: new Date().toISOString() },
          { tenantMode, disableToast: true },
        );
        return resolvePartnerRevenue(summary);
      } catch {
        return null;
      }
    },
    staleTime: 60 * 1000,
  });
